import { render, staticRenderFns } from "./KOLSwiper.vue?vue&type=template&id=053df403&scoped=true&"
import script from "./KOLSwiper.vue?vue&type=script&lang=ts&"
export * from "./KOLSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./KOLSwiper.vue?vue&type=style&index=0&id=053df403&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053df403",
  null
  
)

export default component.exports